import { useTranslation } from 'react-i18next'
import Form from '$components/Form'
import createColumnsConfig from './createColumnsConfig'
import { StyledTable } from './styledComponents'

const ProviderOffersList = ({
  orderPartId,
  providerOffers,
  setProviderOffers,
  selectedKey,
  setSelectedKey,
  providerOffersStored,
  invalidProviderOffers,
  deleteProviderOffer: deleteProviderOfferFromCalculation,
}) => {
  const { t } = useTranslation()

  const formData = Form.useWatch()
  const providerOfferFormData = formData?.[orderPartId]

  const onRow = (record) => {
    return {
      onClick: () => {
        setSelectedKey(record.key)
      },
    }
  }

  const addProviderOffer = () => {
    const newUUID = crypto.randomUUID()
    const firstOffer = providerOffers[0] || {}
    const newData = {
      key: newUUID,
      offer_id: newUUID,
      amount: null,
      base_price: 0,
      base_production_time: firstOffer.base_production_time || 1,
      editable: true,
      price_rules: {},
      production_time_rules: {},
      allow_partial_delivery: firstOffer.allow_partial_delivery || false,
      allow_other_suppliers: firstOffer.allow_other_suppliers || false,
      allow_subcontractors: firstOffer.allow_subcontractors || false,
      desired_delivery_date: firstOffer.desired_delivery_date || null,
    }
    setProviderOffers([...providerOffers, newData])
    setSelectedKey(newUUID)
  }

  const deleteProviderOffer = (keyToDelete) => {
    if (providerOffers.length <= 1) {
      return
    }
    const newData = providerOffers.filter((item) => item.key !== keyToDelete)
    setProviderOffers(newData)
    deleteProviderOfferFromCalculation({ orderPartId, offerId: keyToDelete })

    if (keyToDelete === selectedKey && newData.length > 0) {
      setSelectedKey(newData[0].key)
    }
  }

  return (
    <>
      <h4>{t('received_requests.batch_offers_title')}</h4>
      <br />
      <StyledTable
        pointerCursor={true}
        columns={createColumnsConfig(
          t,
          orderPartId,
          providerOfferFormData,
          invalidProviderOffers,
          addProviderOffer,
          deleteProviderOffer,
          providerOffersStored,
          true, // Add batch mode flag
          providerOffers, // Pass providerOffers for rebate calculation
        )}
        dataSource={providerOffers}
        size="small"
        rowClassName={(record) => {
          const rowClassNames = []
          if (record.key === selectedKey) {
            rowClassNames.push('selected-row')
          }
          if (invalidProviderOffers.includes(record.key)) {
            rowClassNames.push('invalid')
          }
          return rowClassNames.join(' ')
        }}
        onRow={onRow}
        pagination={false}
      />
    </>
  )
}

export default ProviderOffersList
